module.exports = __webpack_public_path__ + "static/hello-4d087c7c2d753b0d5e2fa851976698b8.jpg";